import React from "react";
import ReactDOM from "react-dom";
// import Handlebars from "handlebars";
const { data } = require('./Contact.data');

import "./Contact.scss";

// const htmlContent = require("./Contact.html");
import htmlContent from './Contact.hbs';// works as template fn

// const template = Handlebars.compile(htmlContent);// fails

const Contact = (props) => {

  const {
    // data
  } = props;

  const h_cont = htmlContent(data);

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: h_cont }} className={`hbs_comp plax-bg`} />
      {/* <div dangerouslySetInnerHTML={{ __html: template(data) }} /> */}
    </>
  );
}

export default Contact
